module.exports = __webpack_public_path__ + "static/media/calendar.37fc720b.svg";